import { Avatar, Box, Tooltip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SmsIcon from "@mui/icons-material/Sms";

const floatingAvatarSx = (background, shadowColor) => ({
   background,
   color: "white",
   transition: "transform 0.2s ease, box-shadow 0.2s ease",
   boxShadow: `0 2px 8px ${shadowColor}`,
   "&:hover": {
      cursor: "pointer",
      background,
      transform: "translateY(-4px) scale(1.1)",
      boxShadow: `0 4px 14px ${shadowColor}`,
   },
});

const ContactFloatingButton = () => {
   return (
      <Box>
         <Tooltip
            title={"Contáctenos"}
            placement="left"
            sx={{
               position: "fixed",
               right: 40,
               bottom: 160,
               zIndex: 10,
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
            }}
            componentsProps={{
               tooltip: {
                  sx: {
                     p: 1,
                     bgcolor: "rgb(255, 255, 255, 0.5)",
                     color: "#162c44",
                     fontFamily: "bold",
                     fontSize: "16px",
                  },
               },
            }}
         >
            <Box>
               <a href="https://wa.me/526622885088" target="_blank" rel="noreferrer noopener">
                  <Avatar
                     sx={floatingAvatarSx(
                        "linear-gradient(to right top, #6BDC4A, #009A73)",
                        "rgba(59, 211, 14, 0.35)"
                     )}
                  >
                     <WhatsAppIcon />
                  </Avatar>
               </a>
            </Box>
         </Tooltip>
         <Tooltip
            title={"Visite nuestro blog"}
            placement="left"
            sx={{
               position: "fixed",
               right: 40,
               bottom: 100,
               zIndex: 10,
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
            }}
            componentsProps={{
               tooltip: {
                  sx: {
                     p: 1,
                     bgcolor: "rgb(255, 255, 255, 0.5)",
                     color: "#162c44",
                     fontFamily: "bold",
                     fontSize: "16px",
                  },
               },
            }}
         >
            <Box>
               <a href="https://blog.lecosy.com.mx/" target="_blank" rel="noreferrer noopener">
                  <Avatar
                     sx={floatingAvatarSx(
                        "linear-gradient(to right top, #162C44, #73808F)",
                        "rgba(22, 44, 68, 0.35)"
                     )}
                  >
                     <SmsIcon />
                  </Avatar>
               </a>
            </Box>
         </Tooltip>
      </Box>
   );
};
export default ContactFloatingButton;
